import React, { useState, useEffect } from 'react';
//Components
import IndexHeader from '../../Components/IndexHeader';
import Index from '../../Components/Index';
import Footer from '../../Components/Footer';
const IndexPage = () =>{
    
    return(
        <>
            <IndexHeader />
            <Index />
            <Footer/>
        </>
    )
}



export default IndexPage;